(function () {
  if (window.__uvpSwiperRequested) return;
  window.__uvpSwiperRequested = true;
  if (typeof window.Swiper !== 'undefined') return;

  let cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
  if (!document.querySelector('link[href="' + cssHref + '"]')) {
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    document.head.appendChild(link);
  }

  let jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
  if (!document.querySelector('script[src="' + jsSrc + '"]')) {
    let script = document.createElement('script');
    script.src = jsSrc;
    script.defer = true;
    document.head.appendChild(script);
  }
})();
